<template>
    <section class="modal-mask superadmin-modal modal-add-recipients">
        <div class="modal-mask-inner" @click="closeOpenModal"></div>
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-body">
                    <div class="title-and-stats">
                        <h2>Add recipients</h2>
                        <div class="recipients-statistics">
                            <div v-for="stat of Object.keys(statistics)">
                                <span>{{ capitalizeFirstLetter(stat) }}:</span>
                                <b :class="stat">{{ statistics[stat] }}</b>
                            </div>
                        </div>
                    </div>

                    <Informative :text="processInfo" />

                    <CustomTable :selectionEnabled="true" theme="error"
                                 :headerRow="headerRow" :rows="tableData" :rowWidths="['40%', 'auto']"
                                 @hasSelectedItems="hasSelectedRows = $event"
                                 @selectedItemIndexes="() => {}"/>
                </div>
                <div class="modal-footer">
                    <CustomButton buttonType="add_users" :buttonText="getAddRecipientsButtonText"
                                  :isDisabled="isAddRecipientsDisabled" :callback="() => addNewEmails(this.emails.newlist)"/>
                    <CustomButton buttonType="done_all" buttonText="Confirm selected"
                                  :isDisabled="!selectedEmails.length" :callback="confirmSelection"/>
                    <CustomButton buttonType="close" :callback="closeOpenModal"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CustomButton from "@/components/superadmin/ux/CustomButton";
    import TableRow from "@/mixins/classes/TableRow";
    import CustomTable from "@/components/superadmin/ux/CustomTable";
    import Informative from "@/components/superadmin/ux/Informative";

    import { capitalizeFirstLetter } from "@/mixins/stringFormatting";

    export default {
        name: "AddRecipients",
        props: ["emails", "selectExistingEmails", "addNewEmails"],
        components: {
            Informative,
            CustomTable,
            CustomButton
        },
        computed: {
            isAddRecipientsDisabled() {
                return this.emails.new.length < 1
            },

            getAddRecipientsButtonText() {
                return `Add recipients (${this.emails.new.length})`
            },

            selectedEmails() {
                return this.tableData.filter(function(obj) {
                    return !!obj.selected;
                }).map(function(obj) {
                    return obj.getItems()[0];
                });
            },
        },
        data() {
            return {
                processInfo: 'You can select checkboxes for emails already in this campaign, then click \'Confirm selected\'. Nothing will be imported, but this is a way how to select specific emails you want to delete or send to.',
                headerRow: ["Existing / Invalid emails", "Reason"],
                tableData: [],
                statistics: {
                    total: 0,
                    existing: 0,
                    valid: 0,
                    invalid: 0
                },
                capitalizeFirstLetter: capitalizeFirstLetter,
            }
        },
        mounted() {
            this.prepareDataForTable()
        },
        methods: {
            confirmSelection() {
                this.selectExistingEmails(this.selectedEmails)
                this.closeOpenModal()
            },

            prepareDataForTable() {
                if (this.emails.length < 1) return;

                this.tableData = [];
                this.setupEmailStatistics();
                this.setupExistingEmails();
                this.setupBrokenOrInvalidEmails();
            },

            setupEmailStatistics() {
                const total = this.emails.new.length + this.emails.exist.length + this.emails.broken.length

                this.statistics = {
                    total,
                    existing: this.emails.exist.length,
                    valid: this.emails.new.length,
                    invalid: this.emails.broken.length,
                }
            },

            setupExistingEmails() {
                for (const existingEmail of this.emails.exist) {
                    const reason = 'Email in import matches email already in this campaign';
                    this.tableData.push(new TableRow([existingEmail, reason]));
                }
            },

            setupBrokenOrInvalidEmails() {
                for (const broken of this.emails.broken) {
                    const reason = this.getBrokenEmailReason(broken.reason);
                    const properties = {
                        areFunctionsDisabled: true,
                    }
                    this.tableData.push(new TableRow([broken.email, reason], {}, properties));
                }
            },

            getBrokenEmailReason(reason) {
                switch (reason) {
                    case "existence":
                        return "Email is not attached to any Edurio user"
                    default:
                        return 'Email format is wrong'
                }
            }
        }
    }
</script>

<style lang="scss">
    .superadmin-modal.modal-add-recipients {
        .informative-text {
            margin: 8px 0;
            padding: 8px 12px;
            font-size: 12px;
        }

        &.modal-mask {
            display: block;
            overflow: hidden scroll;
        }

        .modal-wrapper {
            display: block;
        }

        .modal-container {
            width: 90%;
            margin: 20px auto;
        }

        .modal-footer {
            .button.done_all:not(.button-disabled) {
                background: $orange;
            }
        }

        .title-and-stats {
            display: flex;
            align-items: center;

            h2 {
                margin: 0 24px 0 0;
            }

            .recipients-statistics {
                display: flex;
                font-size: 14px;

                b {
                    margin-right: 16px;

                    &.existing {
                        color: $deep-orange;
                    }

                    &.valid {
                        color: $green;
                    }

                    &.invalid {
                        color: $error;
                    }
                }
            }
        }
    }
</style>